// removed by extract-text-webpack-plugin
module.exports = {"container":"styles--container--3l6vQFra","logo":"styles--logo--1jbj6l5K"};


//////////////////
// WEBPACK FOOTER
// ./src/common/components/Layout/OnboardingAccountHeader/styles.css
// module id = 1139
// module chunks = 2